"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _ListContext = _interopRequireDefault(require("./ListContext"));

var _ListModule = _interopRequireDefault(require("./List.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var List = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _clsx;

  var children = props.children,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disablePadding = props.disablePadding,
      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
      subheader = props.subheader,
      direction = props.direction,
      other = _objectWithoutProperties(props, ["children", "className", "component", "dense", "disablePadding", "subheader", "direction"]);

  var context = _react["default"].useMemo(function () {
    return {
      dense: dense
    };
  }, [dense]);

  return /*#__PURE__*/_react["default"].createElement(_ListContext["default"].Provider, {
    value: context
  }, /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: (0, _clsx2["default"])(_ListModule["default"].list, (_clsx = {}, _defineProperty(_clsx, _ListModule["default"]['list--dense'], dense), _defineProperty(_clsx, _ListModule["default"]['list--padding'], !disablePadding), _defineProperty(_clsx, _ListModule["default"]['list--subheader'], subheader), _defineProperty(_clsx, _ListModule["default"].directionX, direction === 'x'), _clsx), className),
    ref: ref
  }, other), subheader, children));
});

List.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes["default"].node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */

  /**
   * @ignore
   */
  className: _propTypes["default"].string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes["default"].elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   */
  dense: _propTypes["default"].bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: _propTypes["default"].bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: _propTypes["default"].node,
  direction: _propTypes["default"].oneOf(['x', 'y'])
};
var _default = List;
exports["default"] = _default;